import { ChevronDown } from "lucide-react";
import { EDITION_COLORS } from "../../lib/api";
import { TierGroup, byTier } from "./TierGroup";

export const groupByEdition = (list, sort) => {
  const order = ["founders", ...Object.keys(EDITION_COLORS), "bespoke"];
  const map = {};
  list.forEach((k) => { const g = k.bespoke ? "bespoke" : k.collection === "founders" ? "founders" : k.edition || "other"; (map[g] = map[g] || []).push(k); });
  return Object.keys(map).sort((a, b) => (order.indexOf(a) + 1 || 99) - (order.indexOf(b) + 1 || 99))
    .map((g) => ({ id: g, kits: sort ? map[g].sort(sort) : map[g], title: g === "founders" ? "Founder's Collection" : g === "bespoke" ? "Bespoke Kits" : `${g} Edition`,
      color: g === "bespoke" ? "#8A5A44" : (EDITION_COLORS[g] || EDITION_COLORS.luxury).primary }));
};

export const EditionGroup = ({ id, title, color, kits, open, onToggle, render, children }) => (
  <section data-testid={`edition-group-${id}`} className="mb-4 rounded-xl border border-stone-200 bg-white overflow-hidden">
    <button data-testid={`edition-toggle-${id}`} onClick={onToggle} aria-expanded={open}
      className="w-full flex items-center gap-3 px-5 py-4 text-left hover:bg-stone-50 transition-colors">
      <span className="h-3 w-3 rounded-full" style={{ background: color }} />
      <span className="font-display text-xl text-[#2B2A26] capitalize">{title}</span>
      <span data-testid={`edition-count-${id}`} className="text-xs font-mono-ui text-stone-500">{kits.length} {children ? "job" : "kit"}{kits.length === 1 ? "" : "s"}</span>
      <ChevronDown size={18} className={`ml-auto text-stone-500 transition-transform duration-200 ${open ? "rotate-180" : ""}`} />
    </button>
    {open && (children || byTier(kits).map((t) => <TierGroup key={t.tier} gid={id} tier={t.tier} label={t.label} kits={t.kits} render={render} />))}
  </section>
);
